import { useRef, useState, useEffect } from "react";
import { RiCalendar2Fill } from "react-icons/ri";
import { useSelector } from "react-redux";
import * as authActions from "../../actions/AuthActions";
import Select from "react-select";
import { RiSortAsc, RiSortDesc } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";
const projectTypeOptions = [
  { value: false, label: "Select" },
  { value: "FIXED BUDGET", label: "FIXED BUDGET" },
  { value: "HOURLY", label: "HOURLY" },
  { value: "SUBSCRIPTION", label: "SUBSCRIPTION" },
];

const invoiceTypeOptions = [
  { value: "", label: "Select" },
  { value: "INVOICE SENT", label: "SENT" },
  { value: "PARTIALLY PAID", label: "PARTIALLY PAID" },
  { value: "PAID", label: "PAID" },
  { value: "PENDING", label: "PENDING" },
  { value: "NON-RECOVERABLE", label: "NON-RECOVERABLE" },
];
const statusOptions = ["PAID", "PENDING"];

const projectStatusOptions = ["ACTIVE", "INACTIVE"];

const CustomFilters = ({
  title,
  type,
  onClick,
  show,
  fetchRecords,
  setFilterUrl,
  backendUrl,
  filterUrl,
  setPage,
  filterVariables,
}) => {
  const {
    vendor,
    setVendor,
    ordering,
    setOrdering,
    paymentStatus,
    setPaymentStatus,
    client,
    setClient,
    status,
    setStatus,
    projectType,
    setProjectType,
    invoiceType,
    setInvoiceType,
    timesheetFilters,
    setTimesheetFilters,
    year,
    setYear,
    month,
    setMonth,
  } = filterVariables;
  const startRef = useRef(null);
  const endRef = useRef(null);
  const { user, token } = useSelector((state) => state.authReducer);

  const [vendorOptions, setVendorOptions] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);

  const [projectOptions, setProjectOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);

  useEffect(() => {
    if (type === "expense") {
      fetchVendors();
    }
    if (type === "project_report") {
      fetchClientOptions();
    }
    if (type === "Timesheets") {
      fetchProjectOptions();
      user?.is_admin && fetchEmployees();
    }
    if (type === "gst_report") {
      fetchYearMonthOptions();
    }
  }, []);

  useEffect(() => {
    if (type === "project_report") {
      handleProjectReportApply();
    }
  }, [status, client, projectType, ordering]);

  useEffect(() => {
    if (type === "expense") {
      handleApply();
    }
  }, [vendor, ordering, paymentStatus]);

  const fetchProjectOptions = async () => {
    const response = await authActions.customAction(
      `project/project/?page_size=all`,
      "fetch",
      null,
      token,
      "Project"
    );
    if (response) {
      const formattedProjects = response.map((item) => ({
        label: item.title,
        value: item.id,
      }));
      setProjectOptions(formattedProjects);
    }
  };

  const fetchEmployees = async () => {
    const response = await authActions.customAction(
      "employee/employee?page_size=all&status=ACTIVE",
      "fetch",
      null,
      token,
      "Employee option"
    );
    if (response) {
      const formattedEmployees = response.map((item) => ({
        label: item?.first_name + " " + item?.last_name,
        value: item.id,
      }));
      setEmployeeOptions(formattedEmployees);
    }
  };

  const fetchClientOptions = async () => {
    const response = await authActions.customAction(
      "project/client?page_size=all",
      "fetch",
      null,
      token,
      "Client option"
    );
    if (response) {
      setClientOptions(response);
    }
  };

  const fetchVendors = async () => {
    const response = await authActions.customAction(
      `expense/vendor?page_size=all`,
      "fetch",
      null,
      token,
      "Team"
    );
    if (response) {
      setVendorOptions(response);
    }
  };
  const fetchYearMonthOptions = async () => {
    const response = await authActions.customAction(
      `invoice/gst-report-options`,
      "fetch",
      null,
      token,
      "GST Report Options"
    );
    if (response) {
      console.log(response)
      setYearOptions(response?.years);
      setMonthOptions(response?.months);
    }
  };
  const handleProjectReportApply = (action) => {
    let url = backendUrl + "?";
    if (client?.value) {
      url = url + `client=${client?.value}&`;
    }
    if (ordering) {
      url = url + `ordering=${ordering}&`;
    }
    if (status) {
      url = url + `status=${status?.value}&`;
    }
    if (projectType?.value) {
      url = url + `project_type=${projectType?.value}&`;
    }
    setFilterUrl(url);
  };

  const handleApply = (action) => {
    let url = backendUrl?.includes("project")
      ? backendUrl + "&"
      : backendUrl + "?";
    if (vendor) {
      url = url + `vendor=${vendor?.value}&`;
    }
    if (ordering) {
      url = url + `ordering=${ordering}&`;
    }
    if (paymentStatus) {
      url = url + `status=${paymentStatus?.value}&`;
    }
    setFilterUrl(url);
    // fetchRecords(url);
  };

  const handleProjectTypeApply = (projectType) => {
    let url = filterUrl;
    const pageRegex = /([?&])page=[^&]*/;
    const projectTypeRegex = /([?&])project_type=[^&]*/;
    if (projectType?.value === false) {
      if (projectTypeRegex.test(url)) {
        url = url.replace(projectTypeRegex, `$1project_type=`);
        url = url.replace(/[?&]$/, "");
      }
    } else if (projectTypeRegex.test(url)) {
      url = url.replace(
        projectTypeRegex,
        `$1project_type=${projectType?.value}`
      );
    } else {
      if (url.includes("?")) {
        url = url.endsWith("&") ? url : `${url}&`;
      } else {
        url = `${url}?`;
      }
      url += `project_type=${projectType?.value}`;
    }
    if (pageRegex.test(url)) {
      url = url.replace(pageRegex, "$1page=1");
    } else {
      if (url.includes("?")) {
        url = url.endsWith("&") ? url : `${url}&`;
      } else {
        url = `${url}?`;
      }
      url += "page=1";
    }
    setPage(1);
    setFilterUrl(url);
    // fetchRecords(url);
  };

  const handleInvocieTypeApply = (selectedOption) => {
    let url = filterUrl;
    const typeRegex = /([?&])status=[^&]*/;
    const pageRegex = /([?&])page=[^&]*/;
    if (selectedOption?.value === false) {
      if (typeRegex.test(url)) {
        url = url.replace(typeRegex, "");
        url = url.replace(/[?&]$/, "");
      }
    } else if (typeRegex.test(url)) {
      url = url.replace(
        typeRegex,
        `$1status=${encodeURIComponent(selectedOption?.value)}`
      );
    } else {
      if (url.includes("?")) {
        url = url.endsWith("&") ? url : `${url}&`;
      } else {
        url = `${url}?`;
      }
      url += `status=${selectedOption?.value}`;
    }

    if (pageRegex.test(url)) {
      url = url.replace(pageRegex, "$1page=1");
    } else {
      if (url.includes("?")) {
        url = url.endsWith("&") ? url : `${url}&`;
      } else {
        url = `${url}?`;
      }
      url += "page=1";
    }
    setPage(1);
    setFilterUrl(url);
    // fetchRecords(url);
  };

  const handleProjectSorting = () => {
    let url = filterUrl;
    const orderingRegex = /([?&])ordering=[^&]*/;
    if (orderingRegex.test(url)) {
      url = url.replace(orderingRegex, (match, prefix) =>
        prefix === "?" ? "?" : ""
      );
      url = url.replace(/[?&]$/, "");
    } else {
      if (url.includes("?")) {
        url = url.endsWith("&") ? url : `${url}&`;
      } else {
        url = `${url}?`;
      }
      url += "ordering=created_on";
    }
    setFilterUrl(url);
    // fetchRecords(url);
  };

  const handleGSTReportApply = (action) => {
    let url = backendUrl + "?";
    if (year?.value) {
      url = url + `year=${year?.value}&`;
    }
    if (month?.value) {
      url = url + `month=${month?.value}&`;
    }
    setFilterUrl(url);
  };

  useEffect(() => {
    if (type === "gst_report") {
      handleGSTReportApply();
    }
  }, [year?.value, month?.value]);

  const handleChange = (field, value) => {
    setTimesheetFilters((prevFilters) => {
      const updatedFilters = { ...prevFilters, [field]: value };
      handleTimesheetApply(updatedFilters);
      return updatedFilters;
    });
  };

  const handleTimesheetApply = (data) => {
    let url = filterUrl
      ? filterUrl
      : backendUrl.includes("?")
        ? backendUrl
        : backendUrl + "?";

    const params = new URLSearchParams(url.split("?")[1]);

    Object.entries(data)?.forEach(([key, value]) => {
      if (value) {
        params.set(key, value.value ?? value);
      } else {
        params.delete(key);
      }
    });

    params.set("page", "1");

    const updatedUrl = `${backendUrl.split("?")[0]}?${params.toString()}`;
    setPage(1);
    setFilterUrl(updatedUrl);
    // fetchRecords(updatedUrl);
  };

  return type !== "expense" && type !== "project_report" ? (
    title === "Project Type" && type !== "gst_report" ? (
      <div
        className="br-5 me-2"
        style={{ border: "0.5px solid #5C707B", color: "#5C707B !important" }}
      >
        <Select
          value={projectType}
          onChange={(selectedOption) => {
            setProjectType(selectedOption);
            handleProjectTypeApply(selectedOption);
          }}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              border: "0px !important",
              boxShadow: "0px !important",
              borderRadius: "15px !important",
              maxWidth: "180px",
              minWidth: "130px",
            }),
          }}
          className={`br-15 fs-15 focus-none ${paymentStatus === "" && "text-para"
            }`}
          options={projectTypeOptions.map((item) => ({
            value: item?.value,
            label: item?.label,
          }))}
          placeholder="Project Type"
        />
      </div>
    ) : type === "gst_report" ?
      (
        <div className="d-flex justify-content-md-end align-items-center flex-wrap w-100 gap-10">
          <div
            className="d-flex br-5"
            style={{ border: "0.5px solid #5C707B", color: "#5C707B !important" }}
          >
            <Select
              value={year}
              onChange={(selectedOption) => {
                setYear(selectedOption);
              }}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  width: "160px",
                  border: "0px !important",
                  boxShadow: "0px !important",
                  borderRadius: "15px !important",
                }),
              }}
              className={`br-15  focus-none ${client === "" && "text-para"}`}
              options={yearOptions?.map((item) => ({
                value: item.id,
                label: item?.name,
              }))}
              placeholder="Year"
            />
          </div>
          <div
            className="d-flex br-5 m-0"
            style={{ border: "0.5px solid #5C707B", color: "#5C707B !important" }}
          >
            <Select
              value={month}
              onChange={(selectedOption) => {
                setMonth(selectedOption);
              }}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  border: "0px !important",
                  boxShadow: "0px !important",
                  borderRadius: "15px !important",
                }),
              }}
              className={`br-15 focus-none ${month === "" && "text-para"}`}
              options={monthOptions.map((item) => ({
                value: item?.value,
                label: item?.label,
              }))}
              placeholder="Month"
            />
          </div>
        </div>
      ) : title === "Invoice Type" ? (
        <div
          className="br-5 me-2"
          style={{ border: "0.5px solid #5C707B", color: "#5C707B !important" }}
        >
          <Select
            value={invoiceType}
            onChange={(selectedOption) => {
              setInvoiceType(selectedOption);
              handleInvocieTypeApply(selectedOption);
            }}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                border: "0px !important",
                boxShadow: "0px !important",
                borderRadius: "15px !important",
                minWidth: "120px",
              }),
            }}
            className={`br-15 focus-none ${paymentStatus === "" && "text-para"}`}
            options={invoiceTypeOptions?.map((item) => ({
              value: item?.value,
              label: item?.label,
            }))}
            placeholder="Invoice Type"
          />
        </div>
      ) : type === "Timesheets" ? (
        <div className="d-flex gap-2">
          <div
            style={{
              border: "0.5px solid #5C707B",
              color: "#5C707B !important",
              position: "relative",
            }}
            className="d-flex bg-white gap-1 align-items-center c-p br-5 p-2"
          >
            <span
              onClick={() => {
                startRef?.current.showPicker();
              }}
              className={` ${timesheetFilters?.start_date === "" && "text-para"}`}
            >
              {timesheetFilters?.start_date
                ? timesheetFilters?.start_date
                : "Start date"}
            </span>
            <RiCalendar2Fill
              size={20}
              color={timesheetFilters?.start_date === "" ? "626262" : "black"}
              onClick={() => {
                startRef?.current.showPicker();
              }}
            />
            {timesheetFilters?.start_date && (
              <RxCross2
                size={20}
                color={timesheetFilters?.start_date === "" ? "626262" : "black"}
                onClick={(e) => handleChange("start_date", "")}
              />
            )}
            <input
              value={timesheetFilters?.start_date}
              onChange={(e) => {
                handleChange("start_date", e.target.value);
              }}
              ref={startRef}
              type="date"
              className="border-none"
              style={{ width: "0px", height: "0px", border: "transparent" }}
            />
          </div>

          <div
            style={{
              border: "0.5px solid #5C707B",
              color: "#5C707B !important",
              position: "relative",
            }}
            className="d-flex bg-white gap-1 align-items-center c-p br-5 p-2"
          >
            <span
              onClick={() => {
                endRef?.current.showPicker();
              }}
              className={` ${timesheetFilters?.end_date === "" && "text-para"}`}
            >
              {timesheetFilters?.end_date
                ? timesheetFilters?.end_date
                : "End date"}
            </span>
            <RiCalendar2Fill
              size={20}
              onClick={() => endRef?.current.showPicker()}
              color={timesheetFilters?.end_date === "" ? "626262" : "black"}
            />
            {timesheetFilters?.end_date && (
              <RxCross2
                size={20}
                color={timesheetFilters?.end_date === "" ? "626262" : "black"}
                onClick={(e) => handleChange("end_date", "")}
              />
            )}
            <input
              value={timesheetFilters?.end_date}
              onChange={(e) => handleChange("end_date", e.target.value)}
              ref={endRef}
              type="date"
              className={`border-none`}
              style={{ width: "0px", border: "transparent" }}
            />
          </div>

          <div
            className="br-5"
            style={{ border: "0.5px solid #5C707B", color: "#5C707B !important" }}
          >
            <Select
              isClearable
              value={timesheetFilters?.project}
              onChange={(selectedOption) =>
                handleChange("project", selectedOption)
              }
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  border: "0px !important",
                  boxShadow: "0px !important",
                  borderRadius: "15px !important",
                  maxWidth: "150px",
                }),
              }}
              className={`br-15 focus-none ${timesheetFilters?.project === "" && "text-para"
                }`}
              options={projectOptions}
              placeholder="Project"
            />
          </div>

          {(user?.is_admin || user?.is_project_manager) && (
            <div
              className="br-5"
              style={{
                border: "0.5px solid #5C707B",
                color: "#5C707B !important",
              }}
            >
              <Select
                isClearable
                value={timesheetFilters?.employee}
                onChange={(selectedOption) =>
                  handleChange("employee", selectedOption)
                }
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    border: "0px !important",
                    boxShadow: "0px !important",
                    borderRadius: "15px !important",
                    maxWidth: "180px",
                  }),
                }}
                className={`br-15 focus-none ${timesheetFilters?.employee === "" && "text-para"
                  }`}
                options={employeeOptions}
                placeholder="Employee"
              />
            </div>
          )}
        </div>
      ) : (
        <div
          onClick={type === "Project" ? handleProjectSorting : onClick}
          style={{ border: "0.5px solid #5C707B", coloe: "#5C707B !important" }}
          className=" bg-white d-flex align-items-center br-5 p-2 m-2 c-p select-none"
        >
          <span className="fs-14 text-para me-1"> {title}</span>
          {show ? <RiSortDesc /> : <RiSortAsc />}
        </div>
      )
  ) : type === "project_report" ? (
    <div className="d-flex justify-content-md-end align-items-center flex-wrap w-100 gap-10">
      <div
        className="d-flex br-5"
        style={{ border: "0.5px solid #5C707B", color: "#5C707B !important" }}
      >
        <Select
          value={client}
          onChange={(selectedOption) => {
            setClient(selectedOption);
          }}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              width: "160px",
              border: "0px !important",
              boxShadow: "0px !important",
              borderRadius: "15px !important",
            }),
          }}
          className={`br-15  focus-none ${client === "" && "text-para"}`}
          options={clientOptions?.map((item) => ({
            value: item.id,
            label: item?.name,
          }))}
          placeholder="Client"
        />
      </div>
      <div
        className="d-flex br-5 m-0"
        style={{ border: "0.5px solid #5C707B", color: "#5C707B !important" }}
      >
        <Select
          value={status}
          onChange={(selectedOption) => {
            setStatus(selectedOption);
          }}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              border: "0px !important",
              boxShadow: "0px !important",
              borderRadius: "15px !important",
            }),
          }}
          className={`br-15 focus-none ${status === "" && "text-para"}`}
          options={projectStatusOptions.map((item) => ({
            value: item,
            label: item,
          }))}
          placeholder="Status"
        />
      </div>
      <div
        className="d-flex br-5 m-0"
        style={{ border: "0.5px solid #5C707B", color: "#5C707B !important" }}
      >
        <Select
          value={projectType}
          onChange={(selectedOption) => {
            setProjectType(selectedOption);
          }}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              border: "0px !important",
              boxShadow: "0px !important",
              borderRadius: "15px !important",
            }),
          }}
          className={`br-15 focus-none ${projectType === "" && "text-para"}`}
          options={projectTypeOptions.map((item) => ({
            value: item?.value,
            label: item?.label,
          }))}
          placeholder="Project Type"
        />
      </div>

      {/* <div
        onClick={() => {
          if (ordering === "created_on") {
            setOrdering("");
          } else {
            setOrdering("created_on");
          }
        }}
        style={{ border: "0.5px solid #5C707B", color: "#5C707B !important" }}
        className="bg-white d-flex align-items-center br-5 p-2 m-2  c-p  select-none"
      >
        <span className="fs-14 text-para me-1">Sort</span>
        {show ? <RiSortDesc /> : <RiSortAsc />}
      </div> */}
    </div>
  ) : (
    <div className="d-flex align-items-center flex-wrap w-100 gap-10">
      <div
        className="d-none br-5"
        style={{ border: "0.5px solid #5C707B", color: "#5C707B !important" }}
      >
        <Select
          value={vendor}
          onChange={(selectedOption) => {
            setVendor(selectedOption);
          }}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              width: "160px",
              border: "0px !important",
              boxShadow: "0px !important",
              borderRadius: "15px !important",
            }),
          }}
          className={`br-15  focus-none ${vendor === "" && "text-para"}`}
          options={vendorOptions?.map((item) => ({
            value: item.id,
            label: item?.name,
          }))}
          placeholder="Vendor"
        />
      </div>
      <div
        className="d-none br-5  m-0"
        style={{ border: "0.5px solid #5C707B", color: "#5C707B !important" }}
      >
        <Select
          value={paymentStatus}
          onChange={(selectedOption) => {
            setPaymentStatus(selectedOption);
          }}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              border: "0px !important",
              boxShadow: "0px !important",
              borderRadius: "15px !important",
            }),
          }}
          className={`br-15 focus-none ${paymentStatus === "" && "text-para"}`}
          options={statusOptions.map((item) => ({
            value: item,
            label: item,
          }))}
          placeholder="Payment Status"
        />
      </div>
    </div>
  );
};

export default CustomFilters;
